import React , {Component} from 'react'
import {Form , Row, Col , Input } from 'antd';



class PersonalDetails extends Component{


    render(){
        return (
            <div style={{padding:"50px"}}>
              
               <Row type="flex" style={{padding:"0px 20px"}} gutter={5} >    
                    <Col span={8}>
                   
                        <Form.Item label="NIC">
                           
                            <Input name="nic_input" value={this.props.employee.NIC}  onChange={this.props.handleChange}></Input>                   
                       
                        </Form.Item>
                    </Col>        
                </Row>      
                <Row type="flex" style={{padding:"0px 20px"}} gutter={10}>  
                    <Col span={6}>  
                 
                    <Form.Item label="First Name">   
    
                            <Input name="first_name_input" value={this.props.employee.first_name}  onChange={this.props.handleChange}></Input>                   
                                    
                    </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Last Name">             
                            <Input name="last_name_input" value={this.props.employee.last_name}   onChange={this.props.handleChange}></Input>                     
                        </Form.Item>
                    </Col>
                </Row>              
          </div>
        )
    }

}


export default PersonalDetails